module.exports = __webpack_public_path__ + "static/media/noimage.6208c820.png";